module.exports = __webpack_public_path__ + "static/img/browse_2.48bd61f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/browse_2.png
// module id = D94W
// module chunks = 1